<div class="main-content" [class.shifted]="cartOpen">
  <router-outlet></router-outlet>
  <!-- This is where all page content loads -->
  <app-cookie-banner></app-cookie-banner>
</div>

<app-restaurant-info-modal
  [restaurantName]="restaurantName"
  [restaurantAddress]="restaurantAddress"
  [restaurantPhone]="restaurantPhone"
  [allergensNote]="allergensNote"
  [openingHours]="openingHoursWeekly"
  [deliveryHours]="deliveryHoursWeekly"
  [fees]="fees"
></app-restaurant-info-modal>
